var map = {
	"./basket.png": 5227,
	"./basket_social.jpeg": 5410,
	"./boxeo.png": 7770,
	"./colonia.png": 2554,
	"./funcional.jpg": 5786,
	"./handball.png": 9637,
	"./hiit.jpeg": 4204,
	"./indoor_cycling.jpeg": 8519,
	"./mamibasket.jpeg": 7224,
	"./pilates.jpeg": 662,
	"./sala.jpg": 6720,
	"./volley.jpeg": 6911,
	"./yoga.png": 733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6441;